const regEx = {
    email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,100}$/i,
    nonEmpty: /^(?!\s*$).+/,
    password: /^.{5,128}$/,
    url: /^(.+)$/,
    zipcode: /^([-\s]*[a-zA-z\d]?[-\s]*){0,9}$/,
};

export const checkString = ({ minLength = 0, maxLength = 10000 }) => value => {
    if (typeof value !== 'string') {
        return false;
    }
    return value.length >= minLength && value.length <= maxLength;
};

export const isNumericString = value => checkString({ minLength: 1 })(value) && !isNaN(value);

export const isValidEmail = value => regEx.email.test(value);
export const isValidPassword = value => regEx.password.test(value);
export const isValidUrl = value => regEx.url.test(value);
export const isValidZipcode = value => regEx.zipcode.test(value);
export const noRestrictions = () => true;

export function isNonEmpty(value) {
    return regEx.nonEmpty.test(value);
}

export const all = (...validators) => value => {
    for (let i = 0; i < validators.length; i++) {
        if (!validators[i](value)) {
            return false;
        }
    }

    return true;
};

export const oneOf = (...validators) => value => {
    for (let i = 0; i < validators.length; i++) {
        if (validators[i](value)) {
            return true;
        }
    }

    return false;
};
